import { render, staticRenderFns } from "./PopularTitle.vue?vue&type=template&id=e5490ce8&scoped=true"
import script from "./PopularTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopularTitle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PopularTitle.vue?vue&type=style&index=0&id=e5490ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5490ce8",
  null
  
)

export default component.exports